// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (max-width: 959px){.empty-list-container[data-v-766b8016]{padding:0 0.625rem}}\n.empty-list-row[data-v-766b8016]{padding-top:5.5rem}\n@media only screen and (max-width: 959px){.empty-list-row[data-v-766b8016]{padding-top:4.0625rem}}", ""]);
// Exports
module.exports = exports;
